import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { HrefLink } from '../atoms/HrefLink';
import bloomaysLogo from '../../assets/logo/bloomays_static_logo.svg';
import hubspotLogo from '../../assets/logo/hubspot_logo.svg';
import { getHubspotDealUrl, getTalentAppJobUrl, getTalentBoardJobUrl } from '@bloomays-lib/utils.shared';

type JobFunnelProjectViewerLinksProps = {
  jobId?: string;
  hiresweetId?: string;
};

const JobFunnelProjectViewerLinks = ({ jobId, hiresweetId }: JobFunnelProjectViewerLinksProps) => {
  const { t } = useTranslation(['jobFunnelProjectViewer']);
  const links: Array<{ href: string; label: string; logo: string; tag?: string }> = [];

  if (jobId) {
    links.push({
      href: getTalentAppJobUrl(jobId),
      label: t('jobLink'),
      logo: bloomaysLogo,
      tag: 'App',
    });
    links.push({
      href: getTalentBoardJobUrl(jobId),
      label: t('talentBoardLink'),
      logo: bloomaysLogo,
      tag: 'TB',
    });
  }

  if (hiresweetId) {
    links.push({
      href: getHubspotDealUrl(hiresweetId),
      label: t('hubspotLink'),
      logo: hubspotLogo,
    });
  }

  if (links.length === 0) {
    return null;
  }

  return (
    <JobInAppLinkRow>
      {links.map((link) => (
        <HrefLink key={`${link.label}-${link.href}`} href={link.href} title={link.label}>
          <IconWithFloatingTag>
            <ExternalLogo src={link.logo} alt={link.label} />
            {link.tag ? <FloatingTag>{link.tag}</FloatingTag> : null}
          </IconWithFloatingTag>
        </HrefLink>
      ))}
    </JobInAppLinkRow>
  );
};

export default JobFunnelProjectViewerLinks;
export { JobFunnelProjectViewerLinks };

const JobInAppLinkRow = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '10px',
  marginBottom: '12px',
  paddingBottom: '12px',
  width: '100%',
  textAlign: 'left',
}));

const ExternalLogo = styled('img')(() => ({
  width: '28px',
  height: '28px',
  objectFit: 'contain',
  display: 'block',
}));

const IconWithFloatingTag = styled('span')(() => ({
  position: 'relative',
  display: 'inline-flex',
  width: '28px',
  height: '28px',
  alignItems: 'center',
  justifyContent: 'center',
  verticalAlign: 'top',
}));

const FloatingTag = styled('span')(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  left: '50%',
  transform: 'translateX(-50%)',
  marginTop: '2px',
  fontSize: '9px',
  lineHeight: '10px',
  fontWeight: 600,
  color: theme.palette.neutral.black,
  whiteSpace: 'nowrap',
}));
